<template>
    <footer class="footer py-5">
      <div class="container-lg py-lg-4 px-3">
        <h2 class="mb-0 fw-bold">CONTACT</h2>
        <div class="d-flex flex-column flex-lg-row justify-content-lg-between mt-4 mt-lg-5">
          <div class="mt-4 mt-lg-0 info" v-for="(item,index) in contactInfo.info" :key="index">
            <h4>{{item.add}}</h4>
            <p class="mt-3 mt-lg-4 lh-lg" v-html="item.content"></p>
          </div>
          <div class="mt-4 mt-lg-0 clearfix">
            <a href="https://twitter.com/fosaltd" target="_blank" class="contactBtn rounded-3 bg-white p-2 p-lg-3 d-flex justify-content-center align-items-center float-start">
              <img src="/static/images/twitterLogo.png" height="25">
            </a>
            <a href="https://www.instagram.com/lim.c.meng.75/" target="_blank" class="contactBtn rounded-3 bg-white p-2 p-lg-3 d-flex justify-content-center align-items-center float-start ms-2">
             <i class="bi bi-instagram fs-2 lh-1 time01"></i>
            </a>
            <a href="https://chimmlim.wordpress.com/" target="_blank" class="contactBtn rounded-3 bg-white p-2 p-lg-3 d-flex justify-content-center align-items-center float-start ms-2">
              <i class="bi bi-wordpress fs-2 lh-1 time01"></i>
            </a>

          </div>
        </div>
        <div class="mt-4 mt-lg-5">
          <small>© FOSA Ltd</small>
        </div>
      </div>
    </footer>
</template>
  
<script>
import axios from '@/axios-auth'
export default {
  data () {
    return {
      contactInfo:''
    }
  },
  created(){
    axios.get('/about.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.contactInfo = response.data.contact
          }
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer{ background-color: #B4B4B4; color: #fff;}
  .info:first-child{ margin-top: 0 !important;}
  .info a{ color: #fff;} 

  @media (min-width: 576px) {
  
  }

  @media (min-width: 768px) {

  }

  @media (min-width: 992px) {
    .contactBtn img{ height: 32px;}
    .footer a:hover{ background-color: #CBB778 !important; color: #000;}
  }

  @media (min-width: 1200px) {

  }

  @media (min-width: 1400px) {
    
  }
</style>
  


// WEBPACK FOOTER //
// src/components/Footer.vue